A component of an application questionnaire.

This only contains identifying metadata;
the `componentTypeCode` can be used to determine the concrete type of the component.
